import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { TypeAnimation } from "react-type-animation";

const PopupOffer = ({open}) => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const pageFullUrl = window.location.href;
  const [error, setError] = useState(null);

  const [data, setData] = useState({
    phone: "",
   path: pageFullUrl,
  });


    const handleNumber = (e) => {
    const value = e.target.value;
    setError(null);

    if (value.length <= 10) {
      setData({
        ...data,
        phone: value,
      });
    }
  };
  

    const link = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    setLoading(true);

    e.preventDefault();

    if (data.phone.length != 10) {
      setError("enter the valid number");
    } else {
    try {
      const response = await fetch(
        // "http://localhost:8001/booking-form",
        `${link}/booking-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        navigate("/booking-confirm");
      } else {
        const res_data = await response.json();
        setError(res_data.message);
      }

    } catch (error) {
      setError("server error");
    }
    }
    
    
    setLoading(false);
  };
  
  
    
  return (
    <div>
      
        <div className="popup-offer">
          <div className="popup-offer-main">
            <div className="popup-offer-close">
              <i
                onClick={() => {
                  open(false);
                }} 
                class="fa-solid fa-circle-xmark"
              ></i>
            </div> 

            <div className="popup-offer-content">
              <div className="popup-offer-heading-1">Get Upto</div>
              <div className="popup-offer-heading-2">30% OFF</div>
              <div className="popup-offer-heading-3">
                <span>
                  <TypeAnimation
                    sequence={[
                      "Pet Grooming Service at Home",
                      3500,
                      "Pet Designer Haircut Services",
                      3500,
                      // "Cage-Free Boarding Service",
                      // 2500,
                      // "Pet Walking Service",
                      // 2500,
                    ]}
                    speed={50}
                    repeat={Infinity}
                  />
                </span>
              </div>

              <form onSubmit={handleSubmit} >
                <input
                        required
                        onChange={handleNumber}
                        value={data.phone}
                        name="phone"
                        type="number"
                        placeholder="Phone Number *"
                      />
                      <div>{error&&error}</div>
                      {
                        loading?
                        <button disabled className="popup-offer-button-error">CONFIRM</button>
                        :
                        <button>CONFIRM</button>
                      }
                      
              </form>
            </div>
          </div>
        </div>
    </div>
  )
}

export default PopupOffer